import { render, staticRenderFns } from "./FlashSalesFilter.vue?vue&type=template&id=81e445a0&"
import script from "./FlashSalesFilter.vue?vue&type=script&lang=js&"
export * from "./FlashSalesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports